<template>
  <RevButtonBase class="text-static-default-hi" @click="toggle">
    <IconBurger />
  </RevButtonBase>
</template>

<script setup lang="ts">
import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconBurger } from '@ds/icons/IconBurger'

import { useBurgerMenuState } from '../../../composables/useBurgerMenuState'

const { toggle } = useBurgerMenuState()
</script>
